import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'image-popup-dialog',
    templateUrl: './image-popup-dialog.component.html',
    styleUrl: './image-popup-dialog.component.css',
    standalone: false
})
export class ImagePopupDialogComponent {
  title: string;
  imageUrl: string;
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ImagePopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImagePopupDialogModel
  ) {
    this.title = data.title;
    this.imageUrl = data.imageUrl;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onImageLoad(): void {
    this.isLoading = false;
  }

  onImageError(): void {
    this.isLoading = false;
    console.error('Failed to load image:', this.imageUrl);
  }
}

export class ImagePopupDialogModel {
  constructor(
    public title: string,
    public imageUrl: string
  ) {}
}